<template>
  <el-card shadow="never">
    <data-list
      :table-style="{ name: 'mixture' }"
      :data="data"
      :columns="column"
      :loading="loading"
      :page="page"
      :page-size="page.pageSize"
      @page-size-changed="pageSizeChanged"
      @page-changed="pageChanged"
      @sort-change="sortChange"
    ></data-list>
  </el-card>
</template>

<script>
import mixin from './mixin';
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
import copyText from '@/components/tools/copy-text';
const datalist = listPageCreate({
  searchConfig: {
    api: api.inquiry.inquiryEntry,
    method: 'POST',
  },
  getQuery(obj, that) {
    return Object.assign({}, obj, {
      customerId: that.customerId,
      timeType: that.timeType,
    });
  },
});
export default {
  name: 'enquiryEntry',
  mixins: [mixin, datalist],
  data() {
    return {
      page: {
        currentPage: 1,
        totalRecords: 0,
        pageSize: 5,
      },
      column: [
        {
          minWidth: 350,
          label: '链接',
          bind: 'formatUrl',
          bindCopy: 'url',
          type: 'custom',
          clickFn(row) {
            window.open(row.url);
          },
          componentName: copyText,
        },
        {
          label: '询盘数',
          bind: 'num',
        },
        {
          label: '占比',
          bind: 'percentageStr',
        },
      ],
    };
  },
};
</script>

<style scoped></style>
